import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireSuperAdmin = false }) {
    const { user, checking } = useAuth();
    const location = useLocation();
    if (checking) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-bone">
                <div className="text-ink/50 text-sm uppercase tracking-[0.2em]" data-testid="auth-loading">
                    Checking session…
                </div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (requireSuperAdmin && user.role !== "super_admin") {
        return <Navigate to="/dashboard" replace />;
    }
    // Super-admins should not see the regular HRM dashboard — bounce them to /companies
    if (!requireSuperAdmin && user.role === "super_admin") {
        return <Navigate to="/companies" replace />;
    }
    // First-login wall: any user whose admin flagged them must rotate their
    // password before touching the rest of the app.
    if (user.force_password_change && location.pathname !== "/change-password") {
        return <Navigate to="/change-password" replace />;
    }
    return children;
}
